export const formatPhoneNumber = (phone: string | undefined): string => {
  if (!phone || typeof phone !== "string") {
    return "";
  }

  const digits = phone.replace(/\D/g, "");
  if (digits.length !== 11) {
    return "";
  }

  // format 8 000 000 00 00
  return [
    digits.slice(0, 1),
    digits.slice(1, 4),
    digits.slice(4, 7),
    digits.slice(7, 9),
    digits.slice(9, 11),
  ].join(" ");
};

export const normalizePhoneDigits = (phone: string): string => {
  const digits = phone.replace(/\D/g, "");
  return digits.length >= 10 ? digits.slice(-10) : "";
};
